import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { trackEvent, EVENTS } from '@/services/analytics'
import type { TickerSelectedPayload } from '@/services/analytics/events'

interface TickerState {
  symbol: string
  name: string
  setTicker: (
    ticker: { symbol: string; name: string },
    source?: TickerSelectedPayload['source'],
  ) => void
  setTickerSymbol: (symbol: string) => void
}

export const useTickerStore = create<TickerState>()(
  devtools(
    (set) => ({
      symbol: 'AAPL',
      name: '',
      setTicker: ({ symbol, name }, source = 'other') => {
        set({ symbol, name }, undefined, 'setTicker')
        trackEvent(EVENTS.TICKER_SELECTED, { symbol, source })
      },
      setTickerSymbol: (symbol) => set({ symbol }, undefined, 'setTickerSymbol'),
    }),
    { name: 'zustand/ticker', store: 'ticker', enabled: import.meta.env.DEV },
  ),
)
